module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic01.2e219b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic01.png
// module id = 535
// module chunks = 1